export default __webpack_public_path__ + "static/media/Head_1_Ear_1_C1.04c5f500.svg";